<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Article Stipend
    </h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3" >
    <div class="col-md-2" style="padding-left: 30px;">
        <label class="mb-0">Financial Year :</label>
        <select class="form-control form-control-xs" [id]="'financialYear'" [name]="'financialYear'"
        type="text" class="form-control form-control-xs" (change)="loadArticleStipend()"
        [(ngModel)]="selectedFY" matTooltip="select Fy year" matTooltipPosition="above">
        <option>Select</option>
        <option *ngFor="let financialYear of financialYearList" [ngValue]="financialYear">{{ financialYear.name }}</option>
        </select>
    </div>
    <div class="col-md-2 offset-md-1">
      <div class="form-group mb-0">
        <label class="mb-0">Branch :</label>
        <select class="form-control form-control-xs" [id]="'branch'" [name]="'branch'"
        type="text" class="form-control form-control-xs" (change)="loadArticleStipend()"
        [(ngModel)]="selectedBranch" matTooltip="select branch" matTooltipPosition="above">
        <option>Select</option>
        <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 offset-md-4">
      <button mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add" matTooltipPosition="left"
      (click)="openModal(modalContent,'add')">
          <i class="fa fa-plus-square" aria-hidden="true" style="color:#ffff"></i>&nbsp;&nbsp; Article Stipend
      </button>
    </div>
  </div>
<div class="pt-2 pb-2">
  <div class="col-md-12">
    <table class="table table-bordered table-striped table-sm">
      <thead class="">
        <tr>
          <th scope="col">Sr.No.</th>
          <th scope="col">Financial Year</th>
          <th scope="col">Article Year</th>
          <th scope="col">Branch</th>
          <th scope="col">Date</th>
          <th scope="col">Stipend</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let modalFormObj of modalFormObjList; index as i">
          <td scope="row">{{i+1}}</td>
          <td>{{modalFormObj.financialYear.name}}</td>
          <td>{{modalFormObj.articleYear}}</td>
          <td>{{modalFormObj.branch.name}}</td>
          <td>{{modalFormObj.effectiveDate | date: 'dd-MMM-yyyy'}}</td>
          <td>{{modalFormObj.stipendPerMonth}}</td>
          <td>
            <button class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,modalFormObj)"
            matTooltip="Click to edit" matTooltipPosition="above">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button> &nbsp;&nbsp;
            <button class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
            matTooltip="Click to delete" matTooltipPosition="above">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</div>
<!-- Modal Template -->
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Article Stipend</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="modalForm">
      <div class="row">
        <label class="col-sm-6">Financial Year :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="financialYear" name="financialYear" type="text" class="form-control form-control-xs"
          formControlName="financialYear"
          [class.is-invalid]="formErrors.financialYear && formSubmitted" matTooltip="{{formErrors.financialYear}}" matTooltipPosition="above">
          <option [value]="null">Select</option>
            <option *ngFor="let financialYear of financialYearList" [ngValue]="financialYear">{{ financialYear.name }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-6">Branch :</label>
        <div class="col-sm-6">
          <select class="form-control form-control-xs" id="branch" name="branch" type="text" class="form-control form-control-xs"
          formControlName="branch"
          [class.is-invalid]="formErrors.branch && formSubmitted" matTooltip="{{formErrors.branch}}" matTooltipPosition="above">
          <option [value]="null">Select</option>
            <option *ngFor="let branch of branchList" [ngValue]="branch">{{ branch.name }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-6">Effective Date :</label>
          <div class="col-sm-6">
          <div class="input-group" >
          <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="effectiveDate" ngbDatepicker
          #effectiveDate="ngbDatepicker" formControlName="effectiveDate" [placement]="'bottom'" [class.is-invalid]="formErrors.effectiveDate && formSubmitted"
          matTooltip="{{formErrors.effectiveDate}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
          <div class="input-group-append">
          <button class="btn btn-outline-theme calendar" (click)="effectiveDate.toggle()" type="button"></button>
          </div>
          </div>
          </div>
      </div>
      <div class="row">
        <label class="col-sm-6">Article Year:</label>
        <div class="col-sm-6">
        <input id="articleYear" name="articleYear" type="number" class="form-control form-control-xs"
        formControlName="articleYear" [class.is-invalid]="formErrors.articleYear && formSubmitted"
        matTooltip="{{formErrors.articleYear}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        </div>
      </div>

      <div class="row">
        <label class="col-sm-6">Stipend Per Month:</label>
        <div class="col-sm-6">
        <input id="stipendPerMonth" name="stipendPerMonth" type="number" class="form-control form-control-xs"
        formControlName="stipendPerMonth" [class.is-invalid]="formErrors.stipendPerMonth && formSubmitted"
        matTooltip="{{formErrors.stipendPerMonth}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
        <div class="col-sm-6"></div>
        <div class="col-sm-3">
          <button  type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
          <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
      </div>
        <div class="col-sm-3">
            <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">Close</button>
        </div>

    </div>
</div>
</ng-template>
